import $ from 'jquery';

class SimpleMap {
	constructor( element, styles ) {
		const self   = this;
		const google = window.google;

		const $el      = $( element );
		const $markers = $el.find( '.marker' );

		const styledMap = new google.maps.StyledMapType( styles, { name: 'Styled Map' } );

		const mapOptions = {
			zoom: 15,
			center: new google.maps.LatLng( 0, 0 ),
			draggable: true,
			scrollwheel: false,
			mapTypeControlOptions: {
				mapTypeIds: [ google.maps.MapTypeId.ROADMAP, 'map_style' ],
			},
		};

		this.map = new google.maps.Map( $el[ 0 ], mapOptions );
		this.map.markers = [];

		this.map.mapTypes.set( 'map_style', styledMap );
		this.map.setMapTypeId( 'map_style' );

		$markers.each( function() {
			self.addMarker( $( this ) );
		} );

		this.centerMap();
	}

	centerMap() {
		const map    = this.map;
		const google = window.google;
		const bounds = new google.maps.LatLngBounds();

		$.each( map.markers, function( i, marker ) {
			const latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
			bounds.extend( latlng );
		} );

		if ( 1 === map.markers.length ) {
			map.setCenter( bounds.getCenter() );
			map.setZoom( 15 );
		} else {
			map.fitBounds( bounds );
		}
	}

	addMarker( $marker ) {
		const map    = this.map;
		const google = window.google;
		const latlng = new google.maps.LatLng( $marker.attr( 'data-lat' ), $marker.attr( 'data-lng' ) );

		const icon = {
			scaledSize: new google.maps.Size( 48, 60 ),
			origin: new google.maps.Point( 0, 0 ),
			anchor: new google.maps.Point( 72, 72 ),
		};

		const marker = new google.maps.Marker( {
			position: latlng,
			map,
			icon,
		} );

		map.markers.push( marker );

		if ( $marker.html() ) {
			let infowindow = null;

			infowindow = new google.maps.InfoWindow( {
				content: $marker.html(),
			} );

			google.maps.event.addListener( marker, 'click', function() {
				infowindow.open( map, marker );
			} );
		}
	}
}

const renderMap = function( $elements, styles ) {
	$( $elements ).each( function() {
		const $curr     = $( this );
		const mapObject = new SimpleMap( $curr, $curr.data( 'mapstyle' ) || styles );
		$curr.data( 'simple-map', mapObject );
	} );
};

// Export.
window.tao_render_map_simple = renderMap; // eslint-disable-line camelcase

$( document ).ready( function() {
	renderMap( $( '.acf-simple-map' ) );
} );
